var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-1",attrs:{"small":"","rounded":"","color":_vm.color,"disabled":_vm.disabled,"data-cy":_vm.dataCy},on:{"click":_vm.click}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }